import type { parseAmplifyConfig } from 'aws-amplify/utils';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import awsConfig from './app-config.json';

export const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: awsConfig.UserPoolId,
      userPoolClientId: awsConfig.UserPoolClientId,
    },
  },
  Storage: {
    S3: {
      bucket: awsConfig.MediaServiceBucketName,
      region: 'us-east-1',
    },
  },
} satisfies Parameters<typeof parseAmplifyConfig>[0];
